module.exports = __webpack_public_path__ + "img/dcms03.0c943e88.png";